
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__seo-guides-zh/[slug]",
      function () {
        return require("private-next-pages/__seo-guides-zh/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__seo-guides-zh/[slug]"])
      });
    }
  